// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-width[data-v-7652c2d0]{width:320px}.card[data-v-7652c2d0]{cursor:default;border-radius:.6rem}\n", "",{"version":3,"sources":["webpack://src/components/common/cards/ReviewCard.vue"],"names":[],"mappings":"AAAA,6BAA6B,WAAW,CAAC,uBAAuB,cAAc,CAAC,mBAAmB","sourcesContent":[".card-width[data-v-7652c2d0]{width:320px}.card[data-v-7652c2d0]{cursor:default;border-radius:.6rem}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
